import React from 'react';

const AtomSpinner = ({ size = 'md' }) => (
  <span className={`atom-spinner ${size === 'lg' ? 'sp-lg' : ''}`} />
);

export default AtomSpinner;
